import { render, staticRenderFns } from "./EditDescription.vue?vue&type=template&id=6454b279&"
import script from "./EditDescription.vue?vue&type=script&lang=js&"
export * from "./EditDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports